// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__KVqaj","ranges":"BmiRanges_ranges__13Zg7"};